import LanguageDTO from '../languageDTO';
export default class ProcessingActivity_TranslationDTO {
  processingActivityId: number;

  languageId: number;

  name: string;

  description?: string;

  purpose?: string

  lang?: LanguageDTO;

  constructor() {
    this.processingActivityId = -1;
    this.languageId = -1;
    this.name = '';
  }
}
